module.exports = __webpack_public_path__ + "static/media/old_practice_version_2.49e13f53.png";